import {useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../_dashboard/helpers'
import dataAxios from '../../../../modules/auth/core/dataAxios'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {buildReservationApiQuery} from '../core/reservationListQuery'

const API_URL = process.env.REACT_APP_API_URL || ''
const apiBase = () => (API_URL || '').replace(/\/api\/?$/i, '')

const ReservationsListToolbar = () => {
  const intl = useIntl()
  const {state} = useQueryRequest()
  const [exporting, setExporting] = useState<'csv' | 'excel' | null>(null)

  const runExport = async (exportAs: 'excel' | 'csv') => {
    try {
      setExporting(exportAs)
      const exportParams = buildReservationApiQuery(state)
      const res = await dataAxios.get(`${API_URL.replace(/\/$/, '')}/export`, {
        params: {
          dataType: 'hotel-reservations',
          exportAs,
          ...exportParams,
        },
      })
      const raw = res.data?.data?.url as string | undefined
      if (!raw) return
      const rel = raw.replace(/^\.\//, '')
      window.open(`${apiBase()}/${rel}`, '_blank', 'noopener,noreferrer')
    } catch (e) {
      console.error(e)
    } finally {
      setExporting(null)
    }
  }

  return (
    <div className='d-flex gap-2 align-items-center'>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        disabled={!!exporting}
        onClick={() => runExport('csv')}
      >
        <KTSVG path='/media/icons/duotune/files/fil021.svg' className='svg-icon-3 me-1' />
        {exporting === 'csv'
          ? '...'
          : intl.formatMessage({id: 'USERS.EXPORT.CSV', defaultMessage: 'Export CSV'})}
      </button>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        disabled={!!exporting}
        onClick={() => runExport('excel')}
      >
        <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-3 me-1' />
        {exporting === 'excel'
          ? '...'
          : intl.formatMessage({id: 'USERS.EXPORT.EXCEL', defaultMessage: 'Export Excel'})}
      </button>
    </div>
  )
}

export {ReservationsListToolbar}
